// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /*.Sava-switcher .Sava-switch {
    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
    border: 1px solid #fff;
  }*/

  .Sava-switcher .Sava-switch {
    background: linear-gradient(to right, #41007b, #000000);
    border: 1px solid #fff;
  }
  
  /* Switcher general css end */
  /* Start Pricing plan style 1 */
  /*.plan-style-1 .plan-header {
    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-1 .plan-button {
    background-image: -webkit-gradient(linear, left top, right top, from(#b76cd2), color-stop(#4c3bb3), color-stop(#4c3bb3), to(#b76cd2));
    background-image: linear-gradient(to right, #b76cd2, #4c3bb3, #4c3bb3, #b76cd2);
    border-radius: 8px;
  }*/

  .plan-style-1 .plan-header {
    background: radial-gradient( 52.22% 169.92% at 50% 54.12%, #41007b 20.77%, #000000 100% );
  }
  .plan-style-1 .plan-button {
    background-image: linear-gradient(to right, #41007b, #000000, #000000, #41007b);
  }

  .plan-style-1 .plan-list li i {
    color: #4c3bb3;
  }

  /*WC 05132022 */
  .title {
    color: #41007b;
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }

  /*WC 05132022 */
  
  /* End Pricing plan style 1 */
  /* Start Pricing plan style 2 */
  .plan-style-2:hover .price {
    color: #4c3bb3;
  }
  .plan-style-2 .plan-button:hover {
    color: #4c3bb3;
  }
  .plan-style-2 .plan-header {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-2 .plan-bottom {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  
  /* End Pricing plan style 2 */
  /* Start Pricing plan style 3 */
  .plan-style-3 .plan-header {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-3 .plan-bottom {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-3 .plan-list li i.far.fa-check-circle {
    color: #4c3bb3;
  }
  .plan-style-3 .plan-button:hover {
    color: #4c3bb3;
  }
  
  /* End Pricing plan style 3 */
  /* Start Pricing plan style 4 */
  .plan-style-4 .plan-header {
    border-bottom: 5px solid #4c3bb3;
  }
  .plan-style-4 .plan-header .plan-label {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-4 .plan-header .plan-icon {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-4 .plan-price {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-4:hover .plan-title {
    color: #4c3bb3;
  }
  .plan-style-4 .plan-button {
    background-image: linear-gradient(to right, #b76cd2, #4c3bb3, #4c3bb3, #b76cd2);
  }
  
  /* End Pricing plan style 4 */
  /* Start Pricing plan style 5 */
  .plan-style-5 .plan-header .lable {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-5 .plan-header .plan-icon {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-5 .plan-price {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  .plan-style-5:hover .plan-title {
    color: #4c3bb3;
  }
  .plan-style-5 .plan-list li i.far.fa-check-circle {
    color: #4c3bb3;
  }
  .plan-style-5 .plan-button {
    color: #4c3bb3;
    border: 2px solid #4c3bb3;
  }

  @media only screen and (max-width: 767px) {
    .plan-style-1 {
      /*max-width: 400px;*/
      max-width: 300px;
      margin: 0 auto 30px auto;
    }
    .plan-style-1 .plan-price .price {
      font-size: 50px;
    }
    .plan-style-1 .plan-price .discount {
      margin: 0;
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      color: #fff;
    }
    .plan-style-1 .plan-price .discount {
      font-size: 25px;
    }
    .plan-style-1 .plan-header .plan-title {
      margin: -14px 0 2px 0;
    }
  
    .plan-style-2 {
      max-width: 400px;
      margin: 0 auto 30px auto;
    }
    .plan-style-2 .plan-price .price {
      font-size: 50px;
    }
    .plan-style-1 .plan-price .discount {
      font-size: 25px;
    }
    .plan-style-3 {
      max-width: 400px;
      margin: 0 auto 30px auto;
    }
    .plan-style-3 .plan-price .price {
      font-size: 50px;
    }
    .plan-style-1 .plan-price .discount {
      font-size: 25px;
    }
    .plan-style-3 .plan-header .plan-title {
      margin: -14px 0 5px 0;
    }
  
    .plan-style-4 {
      max-width: 400px;
      margin: 0 auto 30px auto;
    }
    .plan-style-4 .plan-price .price {
      font-size: 50px;
      padding: 20px 0 10px 0;
    }
  
    .plan-style-5 {
      max-width: 400px;
      margin: 0 auto 30px auto;
    }
    .plan-style-5 .plan-price .price {
      font-size: 50px;
      padding: 20px 0 10px 0;
    }
  
    .Sava-wrapper {
      max-width: 400px;
      margin: 0 auto 30px auto;
    }
  }
  @media only screen and (max-width: 576px) {
    .plan-style-1 {
      /*max-width: 350px;*/
      max-width: 300px;
    }
    .plan-style-1 .plan-price .price {
      font-size: 48px;
    }
    .plan-style-1 .plan-price .discount {
      margin: 0;
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      color: #fff;
    }
    .plan-style-1 .plan-price .discount {
      font-size: 24px;
    }
    .plan-style-2 {
      max-width: 350px;
    }
    .plan-style-2 .plan-price .price {
      font-size: 48px;
    }
  
    .plan-style-3 {
      max-width: 350px;
    }
    .plan-style-3 .plan-price .price {
      font-size: 48px;
    }
  
    .plan-style-4 {
      max-width: 350px;
    }
    .plan-style-4 .plan-price .price {
      font-size: 48px;
    }
  
    .plan-style-5 {
      max-width: 350px;
    }
    .plan-style-5 .plan-price .price {
      font-size: 48px;
    }
  
    .Sava-wrapper {
      max-width: 350px;
    }
  }

  /*==============
	Page General css
=================*/
body {
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  h1 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  h2 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
    margin-top: -5px;
    font-weight: 600;
    color: #555;
  }
  
  h3 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  h4 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  h5 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  h6 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  .pp-section {
    padding: 100px 0 85px 0;
  }
  
  .section-header {
    margin-bottom: 20px;
  }
  
  .section-bg {
    background-color: #eee;
  }
  
  .color-picker {
    position: fixed;
    right: -190px;
    top: 200px;
    width: 190px;
    z-index: 9;
    transition: all 0.3s ease;
  }
  .color-picker .settings-header {
    background: linear-gradient(to right, #777, #444);
    padding: 5px 15px;
  }
  .color-picker .settings-header h3 {
    color: #fff;
    margin: 0;
    font-size: 20px;
    text-align: center;
    padding: 4px 9px;
  }
  .color-picker .section {
    background: #fff;
    padding: 20px;
    border: 1px solid #444;
    overflow: auto;
  }
  .color-picker .section i {
    font-size: 16px;
    margin-right: 10px;
  }
  .color-picker a.handle {
    position: absolute;
    right: 190px;
    width: 50px;
    height: 43px;
    color: #fff;
    transition: all ease-in 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    z-index: -1;
    text-decoration: none;
    background: linear-gradient(to right, #777, #444);
    top: 0;
  }
  .color-picker .colors a {
    width: 35px;
    height: 35px;
    margin: 7px 7px;
    float: left;
    transition: all ease-in 0.3s;
  }
  .color-picker .skin a {
    display: block;
    width: 70px;
    height: 30px;
    margin-left: 0;
    margin-top: 0;
    margin-right: 5px;
    float: left;
    text-align: center;
    line-height: 30px;
    border: 2px transparent solid;
  }
  .color-picker .skin a.actt {
    border: 2px #fff solid;
  }
  
  .color-1 {
    background: linear-gradient(to right, #b76cd2, #4c3bb3);
  }
  
  .color-2 {
    background: linear-gradient(to right, #00eefa, #05b6eb);
  }
  
  .color-3 {
    background: linear-gradient(to right, #ff9f0e, #ff4a10);
  }
  
  .color-4 {
    background: linear-gradient(to right, #09e072, #007d1d);
  }
  
  .color-5 {
    background: linear-gradient(to right, #ff729b, #ce002f);
  }
  
  .color-6 {
    background: linear-gradient(to right, #fde08d, #df9f28);
  }
  
  .plan-header .plan-title {
    /*font-family: "Lato", sans-serif;*/
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  .plan-price .price {
    /*font-family: "Lato", sans-serif;*/
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  .plan-list li {
    /*font-family: "Lato", sans-serif;*/
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  .plan-button {
    /*font-family: "Lato", sans-serif;*/
    font-family: Roboto, "Helvetica Neue", sans-serif;
  }
  
  /*==============
      End Page General css
  =================*/
  /* Start Pricing plan style 1 */
  .plan-style-1 {
    margin: 0 auto 30px auto;
    overflow: hidden;
    position: relative;
    text-align: center;
    box-shadow: 0px 0px 30px #eee;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-1:hover {
    box-shadow: 0px 0px 30px #ccc;
  }
  .plan-style-1 .plan-header {
    padding: 30px 0 40px 0;
    position: relative;
  }
  .plan-style-1 .plan-header:after {
    content: "";
    display: block;
    width: 100%;
    height: 25px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: url('header_style_1.png');
    background-size: 100% 100%;
    background-position: top;
    background-repeat: no-repeat;
  }
  .plan-style-1 .plan-header .plan-title {
    margin: -14px 0 4px 0;
    color: #f7f7f7;
    line-height: 40px;
    font-size: 20px;
    font-weight: 400;
  }
  .plan-style-1 .plan-price .price {
    margin: 0;
    font-size: 55px;
    font-weight: 900;
    line-height: 46px;
    color: #fff;
  }
  .plan-style-1 .plan-price .discount {
    margin: 0;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
  }

  .plan-style-1 .plan-price .price span {
    padding: 0 5px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
  .plan-style-1 .plan-price .discount span {
    padding: 0 5px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
  .plan-style-1 .plan-list {
    padding: 15px 0;
    margin-bottom: 0;
    background-color: #fff;
    position: relative;
    z-index: 1;
    /*WC 05132022*/
    text-align: left;
    /*WC 05132022*/
  }
  .plan-style-1 .plan-list li {
    margin: 0 30px;
    position: relative;
    list-style-type: none;
    color: #888;
    line-height: 35px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.02rem;
  }
  .plan-style-1 .plan-list li i {
    margin-right: 5px;
    position: relative;
    font-size: 13px;
    line-height: 42px;
  }
  .plan-style-1 .plan-list li i.far.fa-times-circle {
    color: red;
  }
  .plan-style-1 .plan-list .tooltip-info {
    cursor: pointer;
  }
  .plan-style-1 .plan-list .tooltip-hover-text {
    color: #555;
    font-weight: 600;
  }
  .plan-style-1 .tooltip-info .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    letter-spacing: 0.02rem;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 2;
    bottom: 35px;
    left: 45%;
    margin-left: -60px;
  }
  .plan-style-1 .tooltip-info .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
  .plan-style-1 .tooltip-info:hover .tooltiptext {
    visibility: visible;
  }
  .plan-style-1 .plan-bottom {
    padding: 10px 0 40px 0;
    position: relative;
    overflow: hidden;
    background: #fff;
  }
  .plan-style-1 .plan-button {
    padding: 13px 30px;
    font-size: 15px;
    color: #fff;
    text-transform: uppercase;
    text-decoration: none;
    background-size: 300% 100%;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-1 .plan-button:hover {
    background-position: 100% 0;
    color: #fff;
    box-shadow: 0px 20px 20px #eee;
    transition: all 0.3s ease-in-out;
  }
  
  /* End Pricing plan style 1 */
  /* Start Pricing plan style 2 */
  .plan-style-2 {
    margin: 0 auto 30px auto;
    overflow: hidden;
    position: relative;
    text-align: center;
    border-radius: 5px;
    box-shadow: 0px 0px 30px #eee;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-2:hover {
    box-shadow: 0px 0px 30px #ccc;
  }
  .plan-style-2 .plan-header {
    position: relative;
    background: #fff;
  }
  .plan-style-2 .plan-header:after {
    content: "";
    display: block;
    width: 100%;
    height: 110px;
    position: absolute;
    bottom: -18px;
    left: 0;
    background-image: url('header_style_2.png');
    background-size: 100% 100%;
    background-position: top;
    background-repeat: no-repeat;
  }
  .plan-style-2 .plan-header .plan-title {
    margin: 0 0 21px 0;
    padding: 15px 0 0 30px;
    text-align: left;
    color: #fff;
    line-height: 42px;
    font-size: 20px;
    font-weight: 400;
  }
  .plan-style-2 .plan-header .plan-title:after {
    content: "";
    width: 60px;
    height: 4px;
    border-radius: 3px;
    background: linear-gradient(to right, #fff, transparent);
    position: absolute;
    top: 49px;
    left: 30px;
  }
  .plan-style-2 .plan-price .price {
    margin: 0 -5px 0 0;
    padding: 10px 30px 0px 30px;
    text-align: right;
    position: relative;
    font-size: 50px;
    color: #777;
    font-weight: 900;
    line-height: 45px;
    z-index: 1;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-2 .plan-price .price span {
    padding: 0 5px;
    font-size: 15px;
    font-weight: 400;
  }
  .plan-style-2 .plan-list {
    padding: 2px 0 20px 0;
    margin-bottom: 0;
    background-color: #fff;
    position: relative;
    z-index: 1;
  }
  .plan-style-2 .plan-list li {
    margin: 0 30px;
    position: relative;
    list-style-type: none;
    color: #888;
    line-height: 35px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.02rem;
  }
  .plan-style-2 .plan-list .tooltip-info {
    cursor: pointer;
  }
  .plan-style-2 .plan-list .tooltip-hover-text {
    color: #555;
    font-weight: 600;
  }
  .plan-style-2 .tooltip-info .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    letter-spacing: 0.02rem;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 2;
    bottom: 35px;
    left: 45%;
    margin-left: -60px;
  }
  .plan-style-2 .tooltip-info .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
  .plan-style-2 .tooltip-info:hover .tooltiptext {
    visibility: visible;
  }
  .plan-style-2 .plan-bottom {
    padding: 70px 0 42px 0;
    position: relative;
    overflow: hidden;
    background: #fff;
  }
  .plan-style-2 .plan-bottom:after {
    content: "";
    width: 100%;
    height: 38px;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('bottom_style_2.png');
    background-size: 100% 100%;
    background-position: top;
    background-repeat: no-repeat;
  }
  .plan-style-2 .plan-button {
    padding: 13px 30px;
    font-size: 15px;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: none;
    color: #fff;
    border: 2px solid #fff;
    
  }
  .plan-style-2 .plan-button:hover {
    background-color: #fff;
    transition: all 0.3s ease-in-out;
  }
  
  /* End Pricing plan style 2 */
  /* Start Pricing plan style 3 */
  .plan-style-3 {
    margin: 0 auto 30px auto;
    overflow: hidden;
    position: relative;
    text-align: center;
    border-radius: 5px;
    box-shadow: 0px 0px 30px #eee;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-3:hover {
    box-shadow: 0px 0px 30px #ccc;
  }
  .plan-style-3 .plan-header {
    padding: 30px 0 38px 0;
    position: relative;
  }
  .plan-style-3 .plan-header:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('header_bg_style_3.png');
    background-size: 100% 100%;
    background-position: bottom;
    background-repeat: no-repeat;
  }
  .plan-style-3 .plan-header .plan-title {
    margin: -14px 0 7px 0;
    position: relative;
    color: #f7f7f7;
    line-height: 40px;
    font-size: 20px;
    font-weight: 400;
  }
  .plan-style-3 .plan-price .price {
    margin: -3px 0 0 0;
    font-size: 55px;
    font-weight: 900;
    line-height: 46px;
    color: #fff;
    position: relative;
  }
  .plan-style-3 .plan-price .price span {
    padding: 0 5px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
  .plan-style-3 .plan-list {
    padding: 16px 0 15px 0;
    margin-bottom: 0;
    background-color: #fff;
  }
  .plan-style-3 .plan-list li {
    margin: 0 30px;
    position: relative;
    list-style-type: none;
    color: #888;
    line-height: 35px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.02rem;
  }
  .plan-style-3 .plan-list li i {
    margin-right: 5px;
    position: relative;
    font-size: 13px;
    line-height: 42px;
  }
  .plan-style-3 .plan-list li i.far.fa-times-circle {
    color: red;
  }
  .plan-style-3 .plan-list .tooltip-info {
    cursor: pointer;
  }
  .plan-style-3 .plan-list .tooltip-hover-text {
    color: #555;
    font-weight: 600;
  }
  .plan-style-3 .tooltip-info .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    letter-spacing: 0.02rem;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 2;
    bottom: 35px;
    left: 45%;
    margin-left: -60px;
  }
  .plan-style-3 .tooltip-info .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
  .plan-style-3 .tooltip-info:hover .tooltiptext {
    visibility: visible;
  }
  .plan-style-3 .plan-bottom {
    padding: 61px 0 42px 0;
    position: relative;
    overflow: hidden;
  }
  .plan-style-3 .plan-bottom:after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('bottom_bg_style_3.png');
    background-size: 100% 100%;
    background-position: top;
    background-repeat: no-repeat;
  }
  .plan-style-3 .plan-button {
    padding: 13px 30px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    text-transform: uppercase;
    text-decoration: none;
    background-image: linear-gradient(45deg, #fff 50%, transparent 50%);
    background-position: 100%;
    background-size: 400%;
    transition: background 300ms ease-in-out;
    border: 2px solid #fff;
    position: relative;
    z-index: 1;
  }
  .plan-style-3 .plan-button:hover {
    background-position: 0%;
    transition: all 0.3s ease-in-out;
  }
  
  /* End Pricing plan style 3 */
  /* Start Pricing plan style 4 */
  .plan-style-4 {
    margin: 0 auto 30px auto;
    overflow: hidden;
    position: relative;
    text-align: center;
    box-shadow: 0px 0px 30px #eee;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-4:hover {
    box-shadow: 0px 0px 30px #ccc;
    transform: scale(1.02);
  }
  .plan-style-4 .plan-header {
    padding: 25px 0 20px 0;
    position: relative;
    background: #fff;
  }
  .plan-style-4 .plan-header .plan-label {
    font-size: 14px;
    line-height: 40px;
    font-weight: 900;
    color: #fff;
    text-transform: uppercase;
    width: 281px;
    text-align: center;
    display: block;
    position: absolute;
    right: -100px;
    top: 15px;
    transition: all 0.5s ease;
    transform: rotate(45deg);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
  }
  .plan-style-4 .plan-header .plan-icon {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px 0 30px 0;
    width: 100px;
    height: 100px;
    display: block;
    border: 5px solid #fff;
    border-radius: 50%;
    color: #fff;
    font-size: 35px;
  }
  .plan-style-4 .plan-header .plan-title {
    margin: 101px 0 -3px 0;
    line-height: 41px;
    font-size: 20px;
    color: #555;
    font-weight: 400;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-4 .plan-price {
    position: relative;
  }
  .plan-style-4 .plan-price:after {
    content: "";
    width: 100%;
    height: 100px;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('price_style_4.png');
    background-size: 100% 100%;
    background-position: bottom;
  }
  .plan-style-4 .plan-price .price {
    margin-bottom: 0;
    padding: 22px 0 10px 0;
    font-size: 55px;
    font-weight: 900;
    line-height: 45px;
    color: #fff;
    position: relative;
    z-index: 1;
  }
  .plan-style-4 .plan-price .price span {
    padding: 0 5px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
  .plan-style-4 .plan-list {
    margin-bottom: 0;
    padding: 17px 0 20px 0;
    background-color: #fff;
    z-index: 1;
  }
  .plan-style-4 .plan-list li {
    margin: 0 30px;
    position: relative;
    list-style-type: none;
    font-size: 14px;
    color: #888;
    font-weight: 400;
    line-height: 35px;
    letter-spacing: 0.02rem;
  }
  .plan-style-4 .plan-list .tooltip-info {
    cursor: pointer;
  }
  .plan-style-4 .plan-list .tooltip-hover-text {
    color: #555;
    font-weight: 600;
  }
  .plan-style-4 .tooltip-info .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    letter-spacing: 0.02rem;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 2;
    bottom: 35px;
    left: 45%;
    margin-left: -60px;
  }
  .plan-style-4 .tooltip-info .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
  .plan-style-4 .tooltip-info:hover .tooltiptext {
    visibility: visible;
  }
  .plan-style-4 .plan-bottom {
    padding: 40px 0;
    position: relative;
    overflow: hidden;
    background: #fff;
  }
  .plan-style-4 .plan-button {
    padding: 13px 30px;
    font-size: 15px;
    color: #fff;
    font-weight: 400;
    text-transform: uppercase;
    text-decoration: none;
    background-size: 300% 100%;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-4 .plan-button:hover {
    background-position: 100% 0;
    color: #fff;
    box-shadow: 0px 20px 20px #eee;
    transition: all 0.3s ease-in-out;
  }
  
  /* End Pricing plan style 4 */
  /* Start Pricing plan style 5 */
  .plan-style-5 {
    margin: 0 auto 30px auto;
    overflow: hidden;
    position: relative;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0px 0px 30px #eee;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-5:hover {
    box-shadow: 0px 0px 30px #ccc;
  }
  .plan-style-5 .plan-header {
    padding: 25px 0 0 0;
    position: relative;
    background: #fff;
  }
  .plan-style-5 .plan-header .lable {
    padding: 3px 8px;
    position: absolute;
    top: 20px;
    right: 0px;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 15px 0px 0px 15px;
  }
  .plan-style-5 .plan-header .plan-icon {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px 0 30px 0;
    width: 100px;
    height: 100px;
    display: block;
    border: 5px solid #fff;
    border-radius: 50%;
    color: #fff;
    font-size: 35px;
  }
  .plan-style-5 .plan-header .plan-title {
    margin: 101px 0 18px 0;
    line-height: 40px;
    font-size: 20px;
    color: #555;
    font-weight: 400;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-5 .plan-price {
    position: relative;
  }
  .plan-style-5 .plan-price:after {
    content: "";
    width: 100%;
    height: 100px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-image: url('price_style_5.png');
    background-size: 100% 100%;
    background-position: bottom;
  }
  .plan-style-5 .plan-price .price {
    margin-bottom: 0;
    padding: 22px 0 10px 0;
    font-size: 55px;
    font-weight: 900;
    line-height: 45px;
    color: #fff;
    position: relative;
    z-index: 1;
  }
  .plan-style-5 .plan-price .price span {
    padding: 0 5px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
  .plan-style-5 .plan-list {
    margin-bottom: 0;
    padding: 17px 30px 16px 30px;
    position: relative;
    background-color: #fff;
  }
  .plan-style-5 .plan-list li {
    position: relative;
    list-style-type: none;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    color: #888;
    letter-spacing: 0.02rem;
    line-height: 40px;
    border-bottom: 1px solid #eee;
  }
  .plan-style-5 .plan-list li:last-child {
    border-bottom: none;
  }
  .plan-style-5 .plan-list li i {
    margin: 0 10px 0 5px;
    float: right;
    position: relative;
    right: -10px;
    font-size: 13px;
    line-height: 40px;
  }
  .plan-style-5 .plan-list li i.far.fa-times-circle {
    color: #fb5757;
  }
  .plan-style-5 .plan-list .tooltip-info {
    cursor: pointer;
  }
  .plan-style-5 .plan-list .tooltip-hover-text {
    color: #555;
    font-weight: 600;
  }
  .plan-style-5 .tooltip-info .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    letter-spacing: 0.02rem;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 2;
    bottom: 35px;
    left: 20%;
    margin-left: -60px;
  }
  .plan-style-5 .tooltip-info .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
  .plan-style-5 .tooltip-info:hover .tooltiptext {
    visibility: visible;
  }
  .plan-style-5 .plan-bottom {
    padding: 13px 0 42px 0;
    position: relative;
    overflow: hidden;
    background: #fff;
  }
  .plan-style-5 .plan-button {
    padding: 13px 30px;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    text-transform: uppercase;
    border-radius: 30px;
  }
  .plan-style-5 .plan-button i {
    margin: 0 0 0 10px;
    font-size: 12px;
    transition: all 0.3s ease-in-out;
  }
  .plan-style-5 .plan-button:hover i {
    margin: 0 0 0 15px;
    transition: all 0.3s ease-in-out;
  }
  
  /* End Pricing plan style 5 */

  /* Sava Default */
.Sava-default{
    margin-bottom: 15px;
    text-align: center;     
    letter-spacing: 1px;
    font-family: 'Lato', sans-serif;
    background: #fff;
}
/* Horizontal Rule(hr tag) line*/
.Sava-default hr{
    margin-top: 0px;
    margin-bottom: 0px;
}
/* To Put 3rd Table into Center */
.m-auto{
    margin: auto !important;
}

/* Sloating Switcher Button */
.Sava-switcher{
    text-align: center;
}
.Sava-switcher .Sava-field{
    margin-bottom: 30px; 
	  display: inline-block;
    position: relative;
    padding: 2px;
    background: radial-gradient( #888888, #555);
	  border: 2px solid #555;
    border-radius: 50em;
    /*WC 05132022*/
    font-family: Roboto, "Helvetica Neue", sans-serif;
    /*WC 05132022*/
}
.Sava-switcher input[type="radio"]{
    position: absolute;
    opacity: 0;
}
.Sava-switcher label{
    position: relative;
    z-index: 1;
    display: inline-block;
    float: left;
    width: 90px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 17px;
    color: #FFFFFF;
    margin-bottom: 0;
}
/* Floating Switcher Button Background */
.Sava-switcher .Sava-switch{
    position: absolute;
    top: 2px;
    left: 2px;
    height: 40px;
    width: 90px;
    border-radius: 50em;
    transition: transform 0.5s;
}
/* Use label:nth-of-type(n) to fix a bug on safari */
.Sava-switcher input[type="radio"]:checked + label + .Sava-switch,
.Sava-switcher input[type="radio"]:checked + label:nth-of-type(n) + .Sava-switch {
    transform: translateX(90px);
}
/* this is the item that rotates */
.Sava-wrapper{
    position: relative;
    padding-left: 0;
    margin-bottom: 0;
}
/* totate the tables - anticlockwise rotation */
.Sava-wrapper.is-switched .is-visible{
    transform: rotateY(180deg);
    animation: Sava-rotate 0.5s;
}
.Sava-wrapper.is-switched .is-hidden{
    transform: rotateY(0);
    animation: Sava-rotate-inverse 0.5s;
    opacity: 0;
}
.Sava-wrapper.is-switched .is-selected{
	opacity: 1;
}
.Sava-wrapper > li {
    list-style-type: none;
    background-color: #FFFFFF;
    backface-visibility: hidden;
    outline: 1px solid transparent;
}
/* subtle gradient layer on the right - to indicate it's possible to scroll */
.Sava-wrapper > li::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(to left, #FFFFFF, rgba(255, 255, 255, 0));
}
/* class added in jQuery - remove the gradient layer when it's no longer possible to scroll */
.Sava-wrapper > li.is-ended::after {
    display: none;
}
/* the front item, visible by default */
.Sava-wrapper .is-visible{
    position: relative;
    z-index: 5;
}
/* the hidden items, right behind the front one */
.Sava-wrapper .is-hidden{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    transform: rotateY(180deg);
}
/* the next item that will be visible */
.Sava-wrapper .is-selected {
    z-index: 3 !important;
}

/* xkeyframes */
@keyframes Sava-rotate {
	0% {
		transform: perspective(2000px) rotateY(0);
	}
	70% {
		/* this creates the bounce effect */
		transform: perspective(2000px) rotateY(200deg);
	}
	100% {
		transform: perspective(2000px) rotateY(180deg);
	}
}
@keyframes Sava-rotate-inverse {
	0% {
		transform: perspective(2000px) rotateY(-180deg);
	}
	70% {
		/* this creates the bounce effect */
		transform: perspective(2000px) rotateY(20deg);
	}
	100% {
		transform: perspective(2000px) rotateY(0);
	}
}

/*WC 05132022*/
@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1275px !important;
  }
}


/*WC 05132022*/
`, "",{"version":3,"sources":["webpack://./src/app/pages/discount-pricing/discount-pricing.component.css"],"names":[],"mappings":"EAAE;;;;IAIE;;EAEF;IACE,uDAAuD;IACvD,sBAAsB;EACxB;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;;;;;;;;IAQE;;EAEF;IACE,yFAAyF;EAC3F;EACA;IAEE,+EAA+E;EACjF;;EAEA;IACE,cAAc;EAChB;;EAEA,eAAe;EACf;IACE,cAAc;IACd,iDAAiD;EACnD;;EAEA,eAAe;;EAEf,6BAA6B;EAC7B,+BAA+B;EAC/B;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IAEE,uDAAuD;EACzD;EACA;IAEE,uDAAuD;EACzD;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IAEE,uDAAuD;EACzD;EACA;IAEE,uDAAuD;EACzD;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IACE,gCAAgC;EAClC;EACA;IAEE,uDAAuD;EACzD;EACA;IAEE,uDAAuD;EACzD;EACA;IAEE,uDAAuD;EACzD;EACA;IACE,cAAc;EAChB;EACA;IAEE,+EAA+E;EACjF;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IAEE,uDAAuD;EACzD;EACA;IAEE,uDAAuD;EACzD;EACA;IAEE,uDAAuD;EACzD;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE;MACE,oBAAoB;MACpB,gBAAgB;MAChB,wBAAwB;IAC1B;IACA;MACE,eAAe;IACjB;IACA;MACE,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,WAAW;IACb;IACA;MACE,eAAe;IACjB;IACA;MACE,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;IACA;MACE,eAAe;MACf,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;IACA;MACE,eAAe;MACf,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;EACF;EACA;IACE;MACE,oBAAoB;MACpB,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;IACA;MACE,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,WAAW;IACb;IACA;MACE,eAAe;IACjB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;;kBAEgB;AAClB;IACI,iDAAiD;EACnD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,iDAAiD;IACjD,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,UAAU;IACV,YAAY;IACZ,UAAU;IAEV,yBAAyB;EAC3B;EACA;IAEE,iDAAiD;IACjD,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,WAAW;IAEX,4BAA4B;IAG5B,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,qBAAqB;IAErB,iDAAiD;IACjD,MAAM;EACR;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IAEX,4BAA4B;EAC9B;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,sBAAsB;EACxB;;EAEA;IAEE,uDAAuD;EACzD;;EAEA;IAEE,uDAAuD;EACzD;;EAEA;IAEE,uDAAuD;EACzD;;EAEA;IAEE,uDAAuD;EACzD;;EAEA;IAEE,uDAAuD;EACzD;;EAEA;IAEE,uDAAuD;EACzD;;EAEA;IACE,mCAAmC;IACnC,iDAAiD;EACnD;;EAEA;IACE,mCAAmC;IACnC,iDAAiD;EACnD;;EAEA;IACE,mCAAmC;IACnC,iDAAiD;EACnD;;EAEA;IACE,mCAAmC;IACnC,iDAAiD;EACnD;;EAEA;;oBAEkB;EAClB,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAEV,6BAA6B;IAErC,gCAAgC;EAClC;EACA;IAEU,6BAA6B;EACvC;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,2CAAiD;IACjD,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;EACtE;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAE1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,WAAW;IAEH,8BAA8B;IAEtC,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAEV,6BAA6B;IAErC,gCAAgC;EAClC;EACA;IAEU,6BAA6B;EACvC;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,2CAAiD;IACjD,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAElB,wDAAwD;IACxD,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IAEV,gCAAgC;EAClC;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;EACtE;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,2CAAiD;IACjD,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,sBAAsB;;EAExB;EACA;IACE,sBAAsB;IAEtB,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAEV,6BAA6B;IAErC,gCAAgC;EAClC;EACA;IAEU,6BAA6B;EACvC;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,8CAAoD;IACpD,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;EACtE;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,8CAAoD;IACpD,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,mEAAmE;IACnE,yBAAyB;IACzB,qBAAqB;IAErB,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,uBAAuB;IAEvB,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAEV,6BAA6B;IAErC,gCAAgC;EAClC;EACA;IAEU,6BAA6B;IAE7B,sBAAsB;EAChC;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,SAAS;IAET,yBAAyB;IAEzB,wBAAwB;IAEhB,8CAA8C;EACxD;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,0CAA8C;IAC9C,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;EACtE;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAE1B,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,WAAW;IAEH,8BAA8B;IAEtC,gCAAgC;EAClC;;EAEA,6BAA6B;EAC7B,+BAA+B;EAC/B;IACE,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IAEX,6BAA6B;IAErC,gCAAgC;EAClC;EACA;IAEU,6BAA6B;EACvC;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gCAAgC;EAClC;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;IAEhB,gCAAgC;EAClC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,0CAAgD;IAChD,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;EACtE;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,eAAe;IAEf,gCAAgC;EAClC;EACA;IACE,kBAAkB;IAElB,gCAAgC;EAClC;;EAEA,6BAA6B;;EAE7B,iBAAiB;AACnB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;AACpB;AACA,gCAAgC;AAChC;IACI,eAAe;IACf,kBAAkB;AACtB;AACA,iCAAiC;AACjC;IACI,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;GACpB,qBAAqB;IACpB,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;GAC5C,sBAAsB;IACrB,mBAAmB;IACnB,cAAc;IACd,iDAAiD;IACjD,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,mBAAmB;IAGnB,0BAA0B;AAC9B;AACA,oDAAoD;AACpD;;IAMI,2BAA2B;AAC/B;AACA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA,+CAA+C;AAC/C;IAKI,0BAA0B;IAG1B,2BAA2B;AAC/B;AACA;IAKI,qBAAqB;IAGrB,mCAAmC;IACnC,UAAU;AACd;AACA;CACC,UAAU;AACX;AACA;IACI,qBAAqB;IACrB,yBAAyB;IAEzB,2BAA2B;IAC3B,8BAA8B;AAClC;AACA,6EAA6E;AAC7E;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,oBAAoB;IAEpB,qEAAqE;AACzE;AACA,6FAA6F;AAC7F;IACI,aAAa;AACjB;AACA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,UAAU;AACd;AACA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,UAAU;IAKV,0BAA0B;AAC9B;AACA,uCAAuC;AACvC;IACI,qBAAqB;AACzB;;AAEA,eAAe;AAyBf;CACC;EAKC,yCAAyC;CAC1C;CACA;EACC,mCAAmC;EAKnC,8CAA8C;CAC/C;CACA;EAKC,8CAA8C;CAC/C;AACD;AAyBA;CACC;EAKC,+CAA+C;CAChD;CACA;EACC,mCAAmC;EAKnC,6CAA6C;CAC9C;CACA;EAKC,yCAAyC;CAC1C;AACD;;AAEA,cAAc;AACd;EACE;IACE,4BAA4B;EAC9B;AACF;;;AAGA,cAAc","sourcesContent":["  /*.Sava-switcher .Sava-switch {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n    border: 1px solid #fff;\n  }*/\n\n  .Sava-switcher .Sava-switch {\n    background: linear-gradient(to right, #41007b, #000000);\n    border: 1px solid #fff;\n  }\n  \n  /* Switcher general css end */\n  /* Start Pricing plan style 1 */\n  /*.plan-style-1 .plan-header {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-1 .plan-button {\n    background-image: -webkit-gradient(linear, left top, right top, from(#b76cd2), color-stop(#4c3bb3), color-stop(#4c3bb3), to(#b76cd2));\n    background-image: linear-gradient(to right, #b76cd2, #4c3bb3, #4c3bb3, #b76cd2);\n    border-radius: 8px;\n  }*/\n\n  .plan-style-1 .plan-header {\n    background: radial-gradient( 52.22% 169.92% at 50% 54.12%, #41007b 20.77%, #000000 100% );\n  }\n  .plan-style-1 .plan-button {\n    background-image: -webkit-gradient(linear, left top, right top, from(#41007b), color-stop(#000000), color-stop(#000000), to(#41007b));\n    background-image: linear-gradient(to right, #41007b, #000000, #000000, #41007b);\n  }\n\n  .plan-style-1 .plan-list li i {\n    color: #4c3bb3;\n  }\n\n  /*WC 05132022 */\n  .title {\n    color: #41007b;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n\n  /*WC 05132022 */\n  \n  /* End Pricing plan style 1 */\n  /* Start Pricing plan style 2 */\n  .plan-style-2:hover .price {\n    color: #4c3bb3;\n  }\n  .plan-style-2 .plan-button:hover {\n    color: #4c3bb3;\n  }\n  .plan-style-2 .plan-header {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-2 .plan-bottom {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  \n  /* End Pricing plan style 2 */\n  /* Start Pricing plan style 3 */\n  .plan-style-3 .plan-header {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-3 .plan-bottom {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-3 .plan-list li i.far.fa-check-circle {\n    color: #4c3bb3;\n  }\n  .plan-style-3 .plan-button:hover {\n    color: #4c3bb3;\n  }\n  \n  /* End Pricing plan style 3 */\n  /* Start Pricing plan style 4 */\n  .plan-style-4 .plan-header {\n    border-bottom: 5px solid #4c3bb3;\n  }\n  .plan-style-4 .plan-header .plan-label {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-4 .plan-header .plan-icon {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-4 .plan-price {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-4:hover .plan-title {\n    color: #4c3bb3;\n  }\n  .plan-style-4 .plan-button {\n    background-image: -webkit-gradient(linear, left top, right top, from(#b76cd2), color-stop(#4c3bb3), color-stop(#4c3bb3), to(#b76cd2));\n    background-image: linear-gradient(to right, #b76cd2, #4c3bb3, #4c3bb3, #b76cd2);\n  }\n  \n  /* End Pricing plan style 4 */\n  /* Start Pricing plan style 5 */\n  .plan-style-5 .plan-header .lable {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-5 .plan-header .plan-icon {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-5 .plan-price {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  .plan-style-5:hover .plan-title {\n    color: #4c3bb3;\n  }\n  .plan-style-5 .plan-list li i.far.fa-check-circle {\n    color: #4c3bb3;\n  }\n  .plan-style-5 .plan-button {\n    color: #4c3bb3;\n    border: 2px solid #4c3bb3;\n  }\n\n  @media only screen and (max-width: 767px) {\n    .plan-style-1 {\n      /*max-width: 400px;*/\n      max-width: 300px;\n      margin: 0 auto 30px auto;\n    }\n    .plan-style-1 .plan-price .price {\n      font-size: 50px;\n    }\n    .plan-style-1 .plan-price .discount {\n      margin: 0;\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 20px;\n      color: #fff;\n    }\n    .plan-style-1 .plan-price .discount {\n      font-size: 25px;\n    }\n    .plan-style-1 .plan-header .plan-title {\n      margin: -14px 0 2px 0;\n    }\n  \n    .plan-style-2 {\n      max-width: 400px;\n      margin: 0 auto 30px auto;\n    }\n    .plan-style-2 .plan-price .price {\n      font-size: 50px;\n    }\n    .plan-style-1 .plan-price .discount {\n      font-size: 25px;\n    }\n    .plan-style-3 {\n      max-width: 400px;\n      margin: 0 auto 30px auto;\n    }\n    .plan-style-3 .plan-price .price {\n      font-size: 50px;\n    }\n    .plan-style-1 .plan-price .discount {\n      font-size: 25px;\n    }\n    .plan-style-3 .plan-header .plan-title {\n      margin: -14px 0 5px 0;\n    }\n  \n    .plan-style-4 {\n      max-width: 400px;\n      margin: 0 auto 30px auto;\n    }\n    .plan-style-4 .plan-price .price {\n      font-size: 50px;\n      padding: 20px 0 10px 0;\n    }\n  \n    .plan-style-5 {\n      max-width: 400px;\n      margin: 0 auto 30px auto;\n    }\n    .plan-style-5 .plan-price .price {\n      font-size: 50px;\n      padding: 20px 0 10px 0;\n    }\n  \n    .Sava-wrapper {\n      max-width: 400px;\n      margin: 0 auto 30px auto;\n    }\n  }\n  @media only screen and (max-width: 576px) {\n    .plan-style-1 {\n      /*max-width: 350px;*/\n      max-width: 300px;\n    }\n    .plan-style-1 .plan-price .price {\n      font-size: 48px;\n    }\n    .plan-style-1 .plan-price .discount {\n      margin: 0;\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 20px;\n      color: #fff;\n    }\n    .plan-style-1 .plan-price .discount {\n      font-size: 24px;\n    }\n    .plan-style-2 {\n      max-width: 350px;\n    }\n    .plan-style-2 .plan-price .price {\n      font-size: 48px;\n    }\n  \n    .plan-style-3 {\n      max-width: 350px;\n    }\n    .plan-style-3 .plan-price .price {\n      font-size: 48px;\n    }\n  \n    .plan-style-4 {\n      max-width: 350px;\n    }\n    .plan-style-4 .plan-price .price {\n      font-size: 48px;\n    }\n  \n    .plan-style-5 {\n      max-width: 350px;\n    }\n    .plan-style-5 .plan-price .price {\n      font-size: 48px;\n    }\n  \n    .Sava-wrapper {\n      max-width: 350px;\n    }\n  }\n\n  /*==============\n\tPage General css\n=================*/\nbody {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  h1 {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  h2 {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    margin-top: -5px;\n    font-weight: 600;\n    color: #555;\n  }\n  \n  h3 {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  h4 {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  h5 {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  h6 {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  .pp-section {\n    padding: 100px 0 85px 0;\n  }\n  \n  .section-header {\n    margin-bottom: 20px;\n  }\n  \n  .section-bg {\n    background-color: #eee;\n  }\n  \n  .color-picker {\n    position: fixed;\n    right: -190px;\n    top: 200px;\n    width: 190px;\n    z-index: 9;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n  }\n  .color-picker .settings-header {\n    background: -webkit-gradient(linear, left top, right top, from(#777), to(#444));\n    background: linear-gradient(to right, #777, #444);\n    padding: 5px 15px;\n  }\n  .color-picker .settings-header h3 {\n    color: #fff;\n    margin: 0;\n    font-size: 20px;\n    text-align: center;\n    padding: 4px 9px;\n  }\n  .color-picker .section {\n    background: #fff;\n    padding: 20px;\n    border: 1px solid #444;\n    overflow: auto;\n  }\n  .color-picker .section i {\n    font-size: 16px;\n    margin-right: 10px;\n  }\n  .color-picker a.handle {\n    position: absolute;\n    right: 190px;\n    width: 50px;\n    height: 43px;\n    color: #fff;\n    -webkit-transition: all ease-in 0.3s;\n    transition: all ease-in 0.3s;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    font-size: 25px;\n    z-index: -1;\n    text-decoration: none;\n    background: -webkit-gradient(linear, left top, right top, from(#777), to(#444));\n    background: linear-gradient(to right, #777, #444);\n    top: 0;\n  }\n  .color-picker .colors a {\n    width: 35px;\n    height: 35px;\n    margin: 7px 7px;\n    float: left;\n    -webkit-transition: all ease-in 0.3s;\n    transition: all ease-in 0.3s;\n  }\n  .color-picker .skin a {\n    display: block;\n    width: 70px;\n    height: 30px;\n    margin-left: 0;\n    margin-top: 0;\n    margin-right: 5px;\n    float: left;\n    text-align: center;\n    line-height: 30px;\n    border: 2px transparent solid;\n  }\n  .color-picker .skin a.actt {\n    border: 2px #fff solid;\n  }\n  \n  .color-1 {\n    background: -webkit-gradient(linear, left top, right top, from(#b76cd2), to(#4c3bb3));\n    background: linear-gradient(to right, #b76cd2, #4c3bb3);\n  }\n  \n  .color-2 {\n    background: -webkit-gradient(linear, left top, right top, from(#00eefa), to(#05b6eb));\n    background: linear-gradient(to right, #00eefa, #05b6eb);\n  }\n  \n  .color-3 {\n    background: -webkit-gradient(linear, left top, right top, from(#ff9f0e), to(#ff4a10));\n    background: linear-gradient(to right, #ff9f0e, #ff4a10);\n  }\n  \n  .color-4 {\n    background: -webkit-gradient(linear, left top, right top, from(#09e072), to(#007d1d));\n    background: linear-gradient(to right, #09e072, #007d1d);\n  }\n  \n  .color-5 {\n    background: -webkit-gradient(linear, left top, right top, from(#ff729b), to(#ce002f));\n    background: linear-gradient(to right, #ff729b, #ce002f);\n  }\n  \n  .color-6 {\n    background: -webkit-gradient(linear, left top, right top, from(#fde08d), to(#df9f28));\n    background: linear-gradient(to right, #fde08d, #df9f28);\n  }\n  \n  .plan-header .plan-title {\n    /*font-family: \"Lato\", sans-serif;*/\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  .plan-price .price {\n    /*font-family: \"Lato\", sans-serif;*/\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  .plan-list li {\n    /*font-family: \"Lato\", sans-serif;*/\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  .plan-button {\n    /*font-family: \"Lato\", sans-serif;*/\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  }\n  \n  /*==============\n      End Page General css\n  =================*/\n  /* Start Pricing plan style 1 */\n  .plan-style-1 {\n    margin: 0 auto 30px auto;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    -webkit-box-shadow: 0px 0px 30px #eee;\n            box-shadow: 0px 0px 30px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-1:hover {\n    -webkit-box-shadow: 0px 0px 30px #ccc;\n            box-shadow: 0px 0px 30px #ccc;\n  }\n  .plan-style-1 .plan-header {\n    padding: 30px 0 40px 0;\n    position: relative;\n  }\n  .plan-style-1 .plan-header:after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 25px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-image: url(\"./img/header_style_1.png\");\n    background-size: 100% 100%;\n    background-position: top;\n    background-repeat: no-repeat;\n  }\n  .plan-style-1 .plan-header .plan-title {\n    margin: -14px 0 4px 0;\n    color: #f7f7f7;\n    line-height: 40px;\n    font-size: 20px;\n    font-weight: 400;\n  }\n  .plan-style-1 .plan-price .price {\n    margin: 0;\n    font-size: 55px;\n    font-weight: 900;\n    line-height: 46px;\n    color: #fff;\n  }\n  .plan-style-1 .plan-price .discount {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #fff;\n  }\n\n  .plan-style-1 .plan-price .price span {\n    padding: 0 5px;\n    font-size: 16px;\n    font-weight: 400;\n    color: #fff;\n  }\n  .plan-style-1 .plan-price .discount span {\n    padding: 0 5px;\n    font-size: 16px;\n    font-weight: 400;\n    color: #fff;\n  }\n  .plan-style-1 .plan-list {\n    padding: 15px 0;\n    margin-bottom: 0;\n    background-color: #fff;\n    position: relative;\n    z-index: 1;\n    /*WC 05132022*/\n    text-align: left;\n    /*WC 05132022*/\n  }\n  .plan-style-1 .plan-list li {\n    margin: 0 30px;\n    position: relative;\n    list-style-type: none;\n    color: #888;\n    line-height: 35px;\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0.02rem;\n  }\n  .plan-style-1 .plan-list li i {\n    margin-right: 5px;\n    position: relative;\n    font-size: 13px;\n    line-height: 42px;\n  }\n  .plan-style-1 .plan-list li i.far.fa-times-circle {\n    color: red;\n  }\n  .plan-style-1 .plan-list .tooltip-info {\n    cursor: pointer;\n  }\n  .plan-style-1 .plan-list .tooltip-hover-text {\n    color: #555;\n    font-weight: 600;\n  }\n  .plan-style-1 .tooltip-info .tooltiptext {\n    visibility: hidden;\n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.8);\n    font-size: 12px;\n    letter-spacing: 0.02rem;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 2;\n    bottom: 35px;\n    left: 45%;\n    margin-left: -60px;\n  }\n  .plan-style-1 .tooltip-info .tooltiptext::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n  }\n  .plan-style-1 .tooltip-info:hover .tooltiptext {\n    visibility: visible;\n  }\n  .plan-style-1 .plan-bottom {\n    padding: 10px 0 40px 0;\n    position: relative;\n    overflow: hidden;\n    background: #fff;\n  }\n  .plan-style-1 .plan-button {\n    padding: 13px 30px;\n    font-size: 15px;\n    color: #fff;\n    text-transform: uppercase;\n    text-decoration: none;\n    background-size: 300% 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-1 .plan-button:hover {\n    background-position: 100% 0;\n    color: #fff;\n    -webkit-box-shadow: 0px 20px 20px #eee;\n            box-shadow: 0px 20px 20px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* End Pricing plan style 1 */\n  /* Start Pricing plan style 2 */\n  .plan-style-2 {\n    margin: 0 auto 30px auto;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 0px 30px #eee;\n            box-shadow: 0px 0px 30px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-2:hover {\n    -webkit-box-shadow: 0px 0px 30px #ccc;\n            box-shadow: 0px 0px 30px #ccc;\n  }\n  .plan-style-2 .plan-header {\n    position: relative;\n    background: #fff;\n  }\n  .plan-style-2 .plan-header:after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 110px;\n    position: absolute;\n    bottom: -18px;\n    left: 0;\n    background-image: url(\"./img/header_style_2.png\");\n    background-size: 100% 100%;\n    background-position: top;\n    background-repeat: no-repeat;\n  }\n  .plan-style-2 .plan-header .plan-title {\n    margin: 0 0 21px 0;\n    padding: 15px 0 0 30px;\n    text-align: left;\n    color: #fff;\n    line-height: 42px;\n    font-size: 20px;\n    font-weight: 400;\n  }\n  .plan-style-2 .plan-header .plan-title:after {\n    content: \"\";\n    width: 60px;\n    height: 4px;\n    border-radius: 3px;\n    background: -webkit-gradient(linear, left top, right top, from(#fff), to(transparent));\n    background: linear-gradient(to right, #fff, transparent);\n    position: absolute;\n    top: 49px;\n    left: 30px;\n  }\n  .plan-style-2 .plan-price .price {\n    margin: 0 -5px 0 0;\n    padding: 10px 30px 0px 30px;\n    text-align: right;\n    position: relative;\n    font-size: 50px;\n    color: #777;\n    font-weight: 900;\n    line-height: 45px;\n    z-index: 1;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-2 .plan-price .price span {\n    padding: 0 5px;\n    font-size: 15px;\n    font-weight: 400;\n  }\n  .plan-style-2 .plan-list {\n    padding: 2px 0 20px 0;\n    margin-bottom: 0;\n    background-color: #fff;\n    position: relative;\n    z-index: 1;\n  }\n  .plan-style-2 .plan-list li {\n    margin: 0 30px;\n    position: relative;\n    list-style-type: none;\n    color: #888;\n    line-height: 35px;\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0.02rem;\n  }\n  .plan-style-2 .plan-list .tooltip-info {\n    cursor: pointer;\n  }\n  .plan-style-2 .plan-list .tooltip-hover-text {\n    color: #555;\n    font-weight: 600;\n  }\n  .plan-style-2 .tooltip-info .tooltiptext {\n    visibility: hidden;\n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.8);\n    font-size: 12px;\n    letter-spacing: 0.02rem;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 2;\n    bottom: 35px;\n    left: 45%;\n    margin-left: -60px;\n  }\n  .plan-style-2 .tooltip-info .tooltiptext::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n  }\n  .plan-style-2 .tooltip-info:hover .tooltiptext {\n    visibility: visible;\n  }\n  .plan-style-2 .plan-bottom {\n    padding: 70px 0 42px 0;\n    position: relative;\n    overflow: hidden;\n    background: #fff;\n  }\n  .plan-style-2 .plan-bottom:after {\n    content: \"\";\n    width: 100%;\n    height: 38px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-image: url(\"./img/bottom_style_2.png\");\n    background-size: 100% 100%;\n    background-position: top;\n    background-repeat: no-repeat;\n  }\n  .plan-style-2 .plan-button {\n    padding: 13px 30px;\n    font-size: 15px;\n    font-weight: 500;\n    text-transform: uppercase;\n    text-decoration: none;\n    color: #fff;\n    border: 2px solid #fff;\n    \n  }\n  .plan-style-2 .plan-button:hover {\n    background-color: #fff;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* End Pricing plan style 2 */\n  /* Start Pricing plan style 3 */\n  .plan-style-3 {\n    margin: 0 auto 30px auto;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 0px 30px #eee;\n            box-shadow: 0px 0px 30px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-3:hover {\n    -webkit-box-shadow: 0px 0px 30px #ccc;\n            box-shadow: 0px 0px 30px #ccc;\n  }\n  .plan-style-3 .plan-header {\n    padding: 30px 0 38px 0;\n    position: relative;\n  }\n  .plan-style-3 .plan-header:before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-image: url(\"./img/header_bg_style_3.png\");\n    background-size: 100% 100%;\n    background-position: bottom;\n    background-repeat: no-repeat;\n  }\n  .plan-style-3 .plan-header .plan-title {\n    margin: -14px 0 7px 0;\n    position: relative;\n    color: #f7f7f7;\n    line-height: 40px;\n    font-size: 20px;\n    font-weight: 400;\n  }\n  .plan-style-3 .plan-price .price {\n    margin: -3px 0 0 0;\n    font-size: 55px;\n    font-weight: 900;\n    line-height: 46px;\n    color: #fff;\n    position: relative;\n  }\n  .plan-style-3 .plan-price .price span {\n    padding: 0 5px;\n    font-size: 16px;\n    font-weight: 400;\n    color: #fff;\n  }\n  .plan-style-3 .plan-list {\n    padding: 16px 0 15px 0;\n    margin-bottom: 0;\n    background-color: #fff;\n  }\n  .plan-style-3 .plan-list li {\n    margin: 0 30px;\n    position: relative;\n    list-style-type: none;\n    color: #888;\n    line-height: 35px;\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0.02rem;\n  }\n  .plan-style-3 .plan-list li i {\n    margin-right: 5px;\n    position: relative;\n    font-size: 13px;\n    line-height: 42px;\n  }\n  .plan-style-3 .plan-list li i.far.fa-times-circle {\n    color: red;\n  }\n  .plan-style-3 .plan-list .tooltip-info {\n    cursor: pointer;\n  }\n  .plan-style-3 .plan-list .tooltip-hover-text {\n    color: #555;\n    font-weight: 600;\n  }\n  .plan-style-3 .tooltip-info .tooltiptext {\n    visibility: hidden;\n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.8);\n    font-size: 12px;\n    letter-spacing: 0.02rem;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 2;\n    bottom: 35px;\n    left: 45%;\n    margin-left: -60px;\n  }\n  .plan-style-3 .tooltip-info .tooltiptext::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n  }\n  .plan-style-3 .tooltip-info:hover .tooltiptext {\n    visibility: visible;\n  }\n  .plan-style-3 .plan-bottom {\n    padding: 61px 0 42px 0;\n    position: relative;\n    overflow: hidden;\n  }\n  .plan-style-3 .plan-bottom:after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-image: url(\"./img/bottom_bg_style_3.png\");\n    background-size: 100% 100%;\n    background-position: top;\n    background-repeat: no-repeat;\n  }\n  .plan-style-3 .plan-button {\n    padding: 13px 30px;\n    font-size: 15px;\n    font-weight: 500;\n    color: #fff;\n    text-transform: uppercase;\n    text-decoration: none;\n    background-image: linear-gradient(45deg, #fff 50%, transparent 50%);\n    background-position: 100%;\n    background-size: 400%;\n    -webkit-transition: background 300ms ease-in-out;\n    transition: background 300ms ease-in-out;\n    border: 2px solid #fff;\n    position: relative;\n    z-index: 1;\n  }\n  .plan-style-3 .plan-button:hover {\n    background-position: 0%;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* End Pricing plan style 3 */\n  /* Start Pricing plan style 4 */\n  .plan-style-4 {\n    margin: 0 auto 30px auto;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    -webkit-box-shadow: 0px 0px 30px #eee;\n            box-shadow: 0px 0px 30px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-4:hover {\n    -webkit-box-shadow: 0px 0px 30px #ccc;\n            box-shadow: 0px 0px 30px #ccc;\n    -webkit-transform: scale(1.02);\n            transform: scale(1.02);\n  }\n  .plan-style-4 .plan-header {\n    padding: 25px 0 20px 0;\n    position: relative;\n    background: #fff;\n  }\n  .plan-style-4 .plan-header .plan-label {\n    font-size: 14px;\n    line-height: 40px;\n    font-weight: 900;\n    color: #fff;\n    text-transform: uppercase;\n    width: 281px;\n    text-align: center;\n    display: block;\n    position: absolute;\n    right: -100px;\n    top: 15px;\n    -webkit-transition: all 0.5s ease;\n    transition: all 0.5s ease;\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(45deg);\n    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);\n            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);\n  }\n  .plan-style-4 .plan-header .plan-icon {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    padding: 20px 0 30px 0;\n    width: 100px;\n    height: 100px;\n    display: block;\n    border: 5px solid #fff;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 35px;\n  }\n  .plan-style-4 .plan-header .plan-title {\n    margin: 101px 0 -3px 0;\n    line-height: 41px;\n    font-size: 20px;\n    color: #555;\n    font-weight: 400;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-4 .plan-price {\n    position: relative;\n  }\n  .plan-style-4 .plan-price:after {\n    content: \"\";\n    width: 100%;\n    height: 100px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-image: url(./img/price_style_4.png);\n    background-size: 100% 100%;\n    background-position: bottom;\n  }\n  .plan-style-4 .plan-price .price {\n    margin-bottom: 0;\n    padding: 22px 0 10px 0;\n    font-size: 55px;\n    font-weight: 900;\n    line-height: 45px;\n    color: #fff;\n    position: relative;\n    z-index: 1;\n  }\n  .plan-style-4 .plan-price .price span {\n    padding: 0 5px;\n    font-size: 16px;\n    font-weight: 400;\n    color: #fff;\n  }\n  .plan-style-4 .plan-list {\n    margin-bottom: 0;\n    padding: 17px 0 20px 0;\n    background-color: #fff;\n    z-index: 1;\n  }\n  .plan-style-4 .plan-list li {\n    margin: 0 30px;\n    position: relative;\n    list-style-type: none;\n    font-size: 14px;\n    color: #888;\n    font-weight: 400;\n    line-height: 35px;\n    letter-spacing: 0.02rem;\n  }\n  .plan-style-4 .plan-list .tooltip-info {\n    cursor: pointer;\n  }\n  .plan-style-4 .plan-list .tooltip-hover-text {\n    color: #555;\n    font-weight: 600;\n  }\n  .plan-style-4 .tooltip-info .tooltiptext {\n    visibility: hidden;\n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.8);\n    font-size: 12px;\n    letter-spacing: 0.02rem;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 2;\n    bottom: 35px;\n    left: 45%;\n    margin-left: -60px;\n  }\n  .plan-style-4 .tooltip-info .tooltiptext::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n  }\n  .plan-style-4 .tooltip-info:hover .tooltiptext {\n    visibility: visible;\n  }\n  .plan-style-4 .plan-bottom {\n    padding: 40px 0;\n    position: relative;\n    overflow: hidden;\n    background: #fff;\n  }\n  .plan-style-4 .plan-button {\n    padding: 13px 30px;\n    font-size: 15px;\n    color: #fff;\n    font-weight: 400;\n    text-transform: uppercase;\n    text-decoration: none;\n    background-size: 300% 100%;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-4 .plan-button:hover {\n    background-position: 100% 0;\n    color: #fff;\n    -webkit-box-shadow: 0px 20px 20px #eee;\n            box-shadow: 0px 20px 20px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* End Pricing plan style 4 */\n  /* Start Pricing plan style 5 */\n  .plan-style-5 {\n    margin: 0 auto 30px auto;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    border-radius: 10px;\n    -webkit-box-shadow: 0px 0px 30px #eee;\n            box-shadow: 0px 0px 30px #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-5:hover {\n    -webkit-box-shadow: 0px 0px 30px #ccc;\n            box-shadow: 0px 0px 30px #ccc;\n  }\n  .plan-style-5 .plan-header {\n    padding: 25px 0 0 0;\n    position: relative;\n    background: #fff;\n  }\n  .plan-style-5 .plan-header .lable {\n    padding: 3px 8px;\n    position: absolute;\n    top: 20px;\n    right: 0px;\n    color: #fff;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    border-radius: 15px 0px 0px 15px;\n  }\n  .plan-style-5 .plan-header .plan-icon {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    padding: 20px 0 30px 0;\n    width: 100px;\n    height: 100px;\n    display: block;\n    border: 5px solid #fff;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 35px;\n  }\n  .plan-style-5 .plan-header .plan-title {\n    margin: 101px 0 18px 0;\n    line-height: 40px;\n    font-size: 20px;\n    color: #555;\n    font-weight: 400;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-5 .plan-price {\n    position: relative;\n  }\n  .plan-style-5 .plan-price:after {\n    content: \"\";\n    width: 100%;\n    height: 100px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    background-image: url(\"./img/price_style_5.png\");\n    background-size: 100% 100%;\n    background-position: bottom;\n  }\n  .plan-style-5 .plan-price .price {\n    margin-bottom: 0;\n    padding: 22px 0 10px 0;\n    font-size: 55px;\n    font-weight: 900;\n    line-height: 45px;\n    color: #fff;\n    position: relative;\n    z-index: 1;\n  }\n  .plan-style-5 .plan-price .price span {\n    padding: 0 5px;\n    font-size: 16px;\n    font-weight: 400;\n    color: #fff;\n  }\n  .plan-style-5 .plan-list {\n    margin-bottom: 0;\n    padding: 17px 30px 16px 30px;\n    position: relative;\n    background-color: #fff;\n  }\n  .plan-style-5 .plan-list li {\n    position: relative;\n    list-style-type: none;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 400;\n    color: #888;\n    letter-spacing: 0.02rem;\n    line-height: 40px;\n    border-bottom: 1px solid #eee;\n  }\n  .plan-style-5 .plan-list li:last-child {\n    border-bottom: none;\n  }\n  .plan-style-5 .plan-list li i {\n    margin: 0 10px 0 5px;\n    float: right;\n    position: relative;\n    right: -10px;\n    font-size: 13px;\n    line-height: 40px;\n  }\n  .plan-style-5 .plan-list li i.far.fa-times-circle {\n    color: #fb5757;\n  }\n  .plan-style-5 .plan-list .tooltip-info {\n    cursor: pointer;\n  }\n  .plan-style-5 .plan-list .tooltip-hover-text {\n    color: #555;\n    font-weight: 600;\n  }\n  .plan-style-5 .tooltip-info .tooltiptext {\n    visibility: hidden;\n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.8);\n    font-size: 12px;\n    letter-spacing: 0.02rem;\n    color: #fff;\n    text-align: center;\n    line-height: 20px;\n    border-radius: 6px;\n    padding: 5px;\n    position: absolute;\n    z-index: 2;\n    bottom: 35px;\n    left: 20%;\n    margin-left: -60px;\n  }\n  .plan-style-5 .tooltip-info .tooltiptext::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n  }\n  .plan-style-5 .tooltip-info:hover .tooltiptext {\n    visibility: visible;\n  }\n  .plan-style-5 .plan-bottom {\n    padding: 13px 0 42px 0;\n    position: relative;\n    overflow: hidden;\n    background: #fff;\n  }\n  .plan-style-5 .plan-button {\n    padding: 13px 30px;\n    text-decoration: none;\n    font-size: 15px;\n    font-weight: 500;\n    text-transform: uppercase;\n    border-radius: 30px;\n  }\n  .plan-style-5 .plan-button i {\n    margin: 0 0 0 10px;\n    font-size: 12px;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  .plan-style-5 .plan-button:hover i {\n    margin: 0 0 0 15px;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* End Pricing plan style 5 */\n\n  /* Sava Default */\n.Sava-default{\n    margin-bottom: 15px;\n    text-align: center;     \n    letter-spacing: 1px;\n    font-family: 'Lato', sans-serif;\n    background: #fff;\n}\n/* Horizontal Rule(hr tag) line*/\n.Sava-default hr{\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n/* To Put 3rd Table into Center */\n.m-auto{\n    margin: auto !important;\n}\n\n/* Sloating Switcher Button */\n.Sava-switcher{\n    text-align: center;\n}\n.Sava-switcher .Sava-field{\n    margin-bottom: 30px; \n\t  display: inline-block;\n    position: relative;\n    padding: 2px;\n    background: radial-gradient( #888888, #555);\n\t  border: 2px solid #555;\n    border-radius: 50em;\n    /*WC 05132022*/\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    /*WC 05132022*/\n}\n.Sava-switcher input[type=\"radio\"]{\n    position: absolute;\n    opacity: 0;\n}\n.Sava-switcher label{\n    position: relative;\n    z-index: 1;\n    display: inline-block;\n    float: left;\n    width: 90px;\n    height: 40px;\n    line-height: 40px;\n    cursor: pointer;\n    font-size: 17px;\n    color: #FFFFFF;\n    margin-bottom: 0;\n}\n/* Floating Switcher Button Background */\n.Sava-switcher .Sava-switch{\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    height: 40px;\n    width: 90px;\n    border-radius: 50em;\n    -webkit-transition: -webkit-transform 0.5s;\n    -moz-transition: -moz-transform 0.5s;\n    transition: transform 0.5s;\n}\n/* Use label:nth-of-type(n) to fix a bug on safari */\n.Sava-switcher input[type=\"radio\"]:checked + label + .Sava-switch,\n.Sava-switcher input[type=\"radio\"]:checked + label:nth-of-type(n) + .Sava-switch {\n    -webkit-transform: translateX(90px);\n    -moz-transform: translateX(90px);\n    -ms-transform: translateX(90px);\n    -o-transform: translateX(90px);\n    transform: translateX(90px);\n}\n/* this is the item that rotates */\n.Sava-wrapper{\n    position: relative;\n    padding-left: 0;\n    margin-bottom: 0;\n}\n/* totate the tables - anticlockwise rotation */\n.Sava-wrapper.is-switched .is-visible{\n    -webkit-transform: rotateY(180deg);\n    -moz-transform: rotateY(180deg);\n    -ms-transform: rotateY(180deg);\n    -o-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n    -webkit-animation: Sava-rotate 0.5s;\n    -moz-animation: Sava-rotate 0.5s;\n    animation: Sava-rotate 0.5s;\n}\n.Sava-wrapper.is-switched .is-hidden{\n    -webkit-transform: rotateY(0);\n    -moz-transform: rotateY(0);\n    -ms-transform: rotateY(0);\n    -o-transform: rotateY(0);\n    transform: rotateY(0);\n    -webkit-animation: Sava-rotate-inverse 0.5s;\n    -moz-animation: Sava-rotate-inverse 0.5s;\n    animation: Sava-rotate-inverse 0.5s;\n    opacity: 0;\n}\n.Sava-wrapper.is-switched .is-selected{\n\topacity: 1;\n}\n.Sava-wrapper > li {\n    list-style-type: none;\n    background-color: #FFFFFF;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    outline: 1px solid transparent;\n}\n/* subtle gradient layer on the right - to indicate it's possible to scroll */\n.Sava-wrapper > li::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    pointer-events: none;\n    background: -webkit-linear-gradient( right , #FFFFFF, rgba(255, 255, 255, 0));\n    background: linear-gradient(to left, #FFFFFF, rgba(255, 255, 255, 0));\n}\n/* class added in jQuery - remove the gradient layer when it's no longer possible to scroll */\n.Sava-wrapper > li.is-ended::after {\n    display: none;\n}\n/* the front item, visible by default */\n.Sava-wrapper .is-visible{\n    position: relative;\n    z-index: 5;\n}\n/* the hidden items, right behind the front one */\n.Sava-wrapper .is-hidden{\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    -webkit-transform: rotateY(180deg);\n    -moz-transform: rotateY(180deg);\n    -ms-transform: rotateY(180deg);\n    -o-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n}\n/* the next item that will be visible */\n.Sava-wrapper .is-selected {\n    z-index: 3 !important;\n}\n\n/* xkeyframes */\n@-webkit-keyframes Sava-rotate{\n\t0% {\n\t\t-webkit-transform: perspective(2000px) rotateY(0);\n\t}\n\t70% {\n\t\t/* this creates the bounce effect */\n\t\t-webkit-transform: perspective(2000px) rotateY(200deg);\n\t}\n\t100% {\n\t\t-webkit-transform: perspective(2000px) rotateY(180deg);\n\t}\n}\n@-moz-keyframes Sava-rotate {\n\t0% {\n\t\t-moz-transform: perspective(2000px) rotateY(0);\n\t}\n\t70% {\n\t\t/* this creates the bounce effect */\n\t\t-moz-transform: perspective(2000px) rotateY(200deg);\n\t}\n\t100% {\n\t\t-moz-transform: perspective(2000px) rotateY(180deg);\n\t}\n}\n@keyframes Sava-rotate {\n\t0% {\n\t\t-webkit-transform: perspective(2000px) rotateY(0);\n\t\t-moz-transform: perspective(2000px) rotateY(0);\n\t\t-ms-transform: perspective(2000px) rotateY(0);\n\t\t-o-transform: perspective(2000px) rotateY(0);\n\t\ttransform: perspective(2000px) rotateY(0);\n\t}\n\t70% {\n\t\t/* this creates the bounce effect */\n\t\t-webkit-transform: perspective(2000px) rotateY(200deg);\n\t\t-moz-transform: perspective(2000px) rotateY(200deg);\n\t\t-ms-transform: perspective(2000px) rotateY(200deg);\n\t\t-o-transform: perspective(2000px) rotateY(200deg);\n\t\ttransform: perspective(2000px) rotateY(200deg);\n\t}\n\t100% {\n\t\t-webkit-transform: perspective(2000px) rotateY(180deg);\n\t\t-moz-transform: perspective(2000px) rotateY(180deg);\n\t\t-ms-transform: perspective(2000px) rotateY(180deg);\n\t\t-o-transform: perspective(2000px) rotateY(180deg);\n\t\ttransform: perspective(2000px) rotateY(180deg);\n\t}\n}\n@-webkit-keyframes Sava-rotate-inverse {\n    0% {\n        -webkit-transform: perspective(2000px) rotateY(-180deg);\n\t}\n    70% {\n        /* this creates the bounce effect */\n        -webkit-transform: perspective(2000px) rotateY(20deg);\n\t}\n    100% {\n        -webkit-transform: perspective(2000px) rotateY(0);\n\t}\n}\n@-moz-keyframes Sava-rotate-inverse {\n    0% {\n        -moz-transform: perspective(2000px) rotateY(-180deg);\n\t}\n    70% {\n        /* this creates the bounce effect */\n        -moz-transform: perspective(2000px) rotateY(20deg);\n\t}\n    100% {\n        -moz-transform: perspective(2000px) rotateY(0);\n\t}\n}\n@keyframes Sava-rotate-inverse {\n\t0% {\n\t\t-webkit-transform: perspective(2000px) rotateY(-180deg);\n\t\t-moz-transform: perspective(2000px) rotateY(-180deg);\n\t\t-ms-transform: perspective(2000px) rotateY(-180deg);\n\t\t-o-transform: perspective(2000px) rotateY(-180deg);\n\t\ttransform: perspective(2000px) rotateY(-180deg);\n\t}\n\t70% {\n\t\t/* this creates the bounce effect */\n\t\t-webkit-transform: perspective(2000px) rotateY(20deg);\n\t\t-moz-transform: perspective(2000px) rotateY(20deg);\n\t\t-ms-transform: perspective(2000px) rotateY(20deg);\n\t\t-o-transform: perspective(2000px) rotateY(20deg);\n\t\ttransform: perspective(2000px) rotateY(20deg);\n\t}\n\t100% {\n\t\t-webkit-transform: perspective(2000px) rotateY(0);\n\t\t-moz-transform: perspective(2000px) rotateY(0);\n\t\t-ms-transform: perspective(2000px) rotateY(0);\n\t\t-o-transform: perspective(2000px) rotateY(0);\n\t\ttransform: perspective(2000px) rotateY(0);\n\t}\n}\n\n/*WC 05132022*/\n@media (min-width: 1200px) {\n  .container, .container-lg, .container-md, .container-sm, .container-xl {\n    max-width: 1275px !important;\n  }\n}\n\n\n/*WC 05132022*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
